
import { useState, useRef } from "react";



//https://www.npmjs.com/package/xlsx
import * as XLSX from 'xlsx';


function Xlsx(props)
{


     
    const fitToColumn = (arrayOfArray) => {
        // get maximum character of each column
        return arrayOfArray[0].map((a, i) => ({ wch: Math.max(...arrayOfArray.map(a2 => a2[i] ? a2[i].toString().length : 0)) }));
    }


    
    const goXLSx = () =>
    {
 
        //var txtBuffer  = "";
        
        const rows = props.tabRef.current?.rows;
        if(!rows)
        {
            console.log("tabRef null");
            return; 
        }


        var tabToXlsx = new Array();


        Array.from(rows).forEach(row => {

        
            var clsName = row.className;

            var cellToXLS = new Array();
           
            const cells = Array.from(row.cells);
            cells.forEach(cell => {

                  //console.log(cell);

                  var txt = cell.innerHTML+"";
                  var tdClsName = cell.className;
                  var childElementCount = cell.childElementCount; //

                  
 

                  txt = txt.replace("&nbsp;","");
                  txt = txt.replace("&nbsp","");

              
                  var spm = txt.split('-');  //czasami są datay 2024-01-12 i cos głupieje..

                  if(spm.length <= 2) //moze byc liczba ujemna
                  {
                            var isNumber = /^\d+\,\d+$/.test(txt);
                            var num = parseFloat(txt);

                          
                            if(  (isNumber || spm.length == 2 ) &&  num != null && num != undefined && !isNaN(num) )
                            {   
                                cellToXLS.push(num); 
                            }else                   
                            cellToXLS.push(txt);
                  }else 
                  cellToXLS.push(txt);

                
                


            });

            //txtBuffer = txtBuffer + "\r\n";
            tabToXlsx.push(cellToXLS);

          });

      
 
        

        //const worksheet = XLSX.utils.json_to_sheet(tabToXlsx);
        const worksheet = XLSX.utils.aoa_to_sheet(tabToXlsx, {raw:true});

        worksheet['!cols'] = fitToColumn(tabToXlsx);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        var title = "elizak.xlsx";
        if(props.title != undefined) title = props.title;

          if(!title.includes(".xlsx") )
          {
              title = title + ".xlsx";
          }

        XLSX.writeFile(workbook, title);

    }


    return (
        <span onClick={goXLSx} className="plg_link">&nbsp;&nbsp;XLSx&nbsp;&nbsp;</span>
    )


}



export default Xlsx;